import "../shared/styles/globals.scss";
import { Provider } from "react-redux";
import { makeStore } from "shared/redux/store";
import Layout from "./ui/Layout";
import { CookiesProvider } from "react-cookie";

const store = makeStore();

function App() {
  return (
    <CookiesProvider>
      <Provider store={store}>
        <Layout />
      </Provider>
    </CookiesProvider>
  );
}

export default App;
